/* eslint-disable @typescript-eslint/indent */
import type { DoctorsService } from './DoctorsService'
import { type FirestoreService } from '../http/FirestoreService'
import { type DoctorType } from '../../model/doctor'
import { getDoc } from 'firebase/firestore'
import { functions } from '../../db'
import { httpsCallable } from 'firebase/functions'

export class DoctorsServiceImpl implements DoctorsService {
  private readonly firestoreService: FirestoreService

  private static readonly collectionName = 'doctor'

  constructor(firestoreService: FirestoreService) {
    this.firestoreService = firestoreService
  }

  async getDoctorProfile({
    ownerId
  }: {
    ownerId: string
  }): Promise<DoctorType | undefined> {
    try {
      const doctorProfile = await this.firestoreService.getDocument<DoctorType>(
        DoctorsServiceImpl.collectionName,
        ownerId
      )

      // resolve schemaId to schema
      if (doctorProfile?.schemaId) {
        const schemaDoc = await getDoc(doctorProfile.schemaId)

        if (!schemaDoc.exists()) {
          throw new Error('Schema not found')
        }

        return {
          ...doctorProfile,
          schema: schemaDoc.data() as DoctorType['schema']
        }
      }

      return doctorProfile
    } catch (error) {
      console.error('Error getting doctor profile', error)
    }
  }

  async onboardDoctor(
    doctorData: Partial<DoctorType> & { schemaId?: string }
  ): Promise<void> {
    const completeOnboarding = httpsCallable(
      functions,
      'completeDoctorOnboarding'
    )
    await completeOnboarding(doctorData)
  }

  async updateDoctorProfile({
    ownerId,
    doctorData
  }: {
    ownerId: string
    doctorData: Partial<DoctorType>
  }): Promise<void> {
    await this.firestoreService.updateDocument(
      DoctorsServiceImpl.collectionName,
      ownerId,
      doctorData
    )
  }

  async contactDoctor({ ownerId }: { ownerId: string }): Promise<void> {
    await this.firestoreService.updateDocument(
      DoctorsServiceImpl.collectionName,
      ownerId,
      { requestedContact: true }
    )
  }
}
